export function transformObjectKeys<
  T extends Record<string, unknown>,
  F extends (key: keyof T & string) => string
>(obj: T, transform: F): Record<ReturnType<F>, T[keyof T]> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [transform(key as keyof T & string), value])
  ) as Record<ReturnType<F>, T[keyof T]>;
}
